import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeDataImportCreate,
  detail: routeDataImportDetail,
  home: routeDataImportHome,
  root: routeDataImportRoot,
} = createDoctypeRoutes({
  createName: 'new-data-import',
  createPath: 'new',
  detailName: 'data-import-detail',
  doctype: DOCTYPES.DATA_IMPORT,
  homeName: 'data-import-home',
  path: 'data-import',
  views: {
    create: async () =>
      await import('@/components/viewsExternal/settings/dataImport/AddDataImport.vue'),
    detail: async () =>
      await import('@/components/viewsExternal/settings/dataImport/ViewDataImport.vue'),
    list: async () =>
      await import('@/components/viewsExternal/settings/dataImport/DataImportView.vue'),
  },
})

export { routeDataImportCreate, routeDataImportDetail, routeDataImportHome, routeDataImportRoot }
